<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-delete"
      title="Delete User"
      ok-only
      ok-title="Delete"
      @ok="deleteItem"
    >
      <b-card-text>
        <h5>{{ $t("common.delete-sure") }}</h5>
        {{ $t("common.sure-click") }}
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.add')} ${$t('lab.TestNormalRanges')}`
          : `${$t('common.edit')} ${$t('lab.TestNormalRanges')}`
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="12">
            <AutoComplete
              :label="$t('lab.test')"
              :placeholder="$t('lab.test')"
              v-model="EditForm.test_id"
              :serializer="(val) => val.id"
              param-query="name"
              endpoint="test"
              text-title="name"
            />
            <p class="text-danger mt-1">{{ errorForm.test_id }}</p>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('lab.min')">
              <b-form-input
                type="number"
                v-model="EditForm.min"
                :placeholder="$t('lab.min')"
              />
              <p class="text-danger mt-1">{{ errorForm.min }}</p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('lab.max')">
              <b-form-input
                type="number"
                v-model="EditForm.max"
                :placeholder="$t('lab.max')"
              />
              <p class="text-danger mt-1">{{ errorForm.max }}</p>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('lab.gender')">
              <v-select
                v-model="EditForm.gender"
                :options="['Male', 'Female']"
                :placeholder="$t('lab.gender')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('lab.min_age')">
              <b-form-input
                type="number"
                v-model="EditForm.min_age"
                :placeholder="$t('lab.min_age')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('lab.max_age')">
              <b-form-input
                type="number"
                v-model="EditForm.max_age"
                :placeholder="$t('lab.max_age')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ createMode ? $t("common.add") : $t("common.edit") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('lab.TestNormalRanges')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.filter") }} {{ $t("lab.TestNormalRanges") }}</h2>
            <br />
          </b-col>

          <b-col md="6" cols="12" class="d-flex align-items-center">
            <AutoComplete
              :label="$t('lab.test')"
              :placeholder="$t('lab.test')"
              v-model="test_id"
              :serializer="(val) => val.id"
              param-query="name"
              endpoint="test"
              text-title="name"
              style="flex: 1"
            />

            <div class="mx-3">
              <b-button variant="primary" @click="getTestList()">
                {{ $t("common.search") }}
                <b-icon-search class="ml-1"></b-icon-search>
              </b-button>
            </div>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("common.table") }} {{ $t("lab.TestNormalRanges") }}</h2>
          <b-button
            v-if="$store.state.app.permissions.includes('store-test')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t("common.create") }} {{ $t("lab.TestNormalRanges") }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="d-flex justify-content-center" style="gap: 10px">
              <b-button
                pill
                size="sm"
                variant="outline-danger"
                @click="deleteModel(data.item)"
              >
                {{ $t("common.delete") }}
              </b-button>
              <b-button
                pill
                size="sm"
                variant="outline-warning"
                @click="show(data.item, 'edit')"
              >
                {{ $t("common.edit") }}
              </b-button>
            </div>
            <!-- <ActionsButtons
              deletePerm="delete-test"
              editPerm="update-test"
              @editToggle="show(data.item)"
              @deleteToggle="deleteModel(data.item)"
            /> -->
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("lab.TestNormalRanges") }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getTestList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import vSelect from "vue-select";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");

export default {
  mixins: [permissionChecker],
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    ActionsButtons,
    vSelect,
    AutoComplete,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {},
      createMode: false,
      errorForm: {
        name: "",
        price: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "test.name", label: this.$t("common.name"), sortable: true },
        { key: "test.price", label: this.$t("lab.price") },
        { key: "gender", label: this.$t("lab.gender") },
        { key: "min", label: this.$t("lab.min") },
        { key: "max", label: this.$t("lab.max") },
        {
          key: "min_age",
          label: this.$t("lab.min_age"),
          sortable: true,
        },
        { key: "max_age", label: this.$t("lab.max_age") },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      test_id: null,
    };
  },
  mounted() {
    this.getTestList();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {};
      } else {
        this.createMode = false;
        console.log(item);
        this.EditForm = {
          id: item.id,
          test_id: item.test_id,
          min: item.min,
          max: item.max,
          gender: item.gender,
          min_age: item.min_age,
          max_age: item.max_age,
          _method: "PUT",
        };
      }
      this.$bvModal.show("modal-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getTestList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/testNormalRanges?page=${this.page}&take=${this.take}&sort=-id&include[]=test`;

      if (this.test_id) {
        url += `&filter[test_id]=${this.test_id}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/testNormalRanges/${this.deleteForm.id}`)
        .then((response) => {
          this.getTestList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      this.loading = true;
      let count = 0;
      this.errorForm.test_id = "";
      this.errorForm.min = "";
      this.errorForm.max = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.test_id) {
        count++;
        this.errorForm.test_id = "The test id field is required.";
      }

      if (!this.EditForm.min) {
        count++;
        this.errorForm.min = "The min field is required.";
      }

      if (!this.EditForm.max) {
        count++;
        this.errorForm.max = "The max field is required.";
      }

      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        const data = {
          id: this.EditForm.id,
          test_id: this.EditForm.test_id,
          min: this.EditForm.min,
          max: this.EditForm.max,
          gender: this.EditForm.gender,
          min_age: this.EditForm.min_age,
          max_age: this.EditForm.max_age,
          _method: this.createMode ? "POST" : "PUT",
        };
        (this.params.form = data),
          (this.params.path = `/testNormalRanges`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getTestList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        console.log(this.EditForm);
        (this.params.form = this.EditForm),
          (this.params.path = `/testNormalRanges/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getTestList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
